import React, { useEffect, useState } from "react";
import "../Styles/style.css";
import AOS from "aos";
import "aos/dist/aos.css";
import config from "../config";

const defaultBanner = {
  banner_image: "",
  banner_title: "Recruitment Services",
  content_text: "<p>Your gateway to finding the right talent faster.</p>",
};

const RecruitmentPage = () => {
  const [banner, setBanner] = useState(defaultBanner);
  const [contents, setContents] = useState([]);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    // Fetch banner
    fetch(
      "/prosapiens-cms/public/api/banners/recruitment"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.banners && data.banners.length > 0) {
          setBanner(data.banners[0]);
        }
      })
      .catch(() => setBanner(defaultBanner));

    // Fetch recruitment content
    fetch(`${config.API_BASE_URL}/content/recruitment`)
      .then((res) => res.json())
      .then((data) => {
        if (data.content && data.content.length > 0) {
          setContents(data.content);
        }
      })
      .catch((err) =>
        console.error("Error fetching recruitment content:", err)
      );
  }, []);

  const getImageUrl = (path) =>
    path?.startsWith("http")
      ? path
      : `/prosapiens-cms/public/${path}`;

  return (
    <>
      {/* Banner */}
      <section
        className="services-recruitment-banner recruitment-mobile"
        style={{
          backgroundImage: `url(${getImageUrl(banner.banner_image)})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="overlay container">
          <div className="hero-text">
            <h1 dangerouslySetInnerHTML={{ __html: banner.banner_title }} />
            <div
              style={{ color: "#fff" }}
              dangerouslySetInnerHTML={{ __html: banner.content_text }}
            />
          </div>
        </div>
      </section>

      {contents.map((item) => {
        const imageUrl = getImageUrl(item.content_image);

        // Section 1 style
        if (item.content_order === "1") {
          return (
            <section className="what-we-do" key={item.id}>
              <div className="container">
                <div className="image-container">
                  <div className="image-side" data-aos="fade-right">
                    <img src={imageUrl} alt="Section visual" />
                  </div>
                  <div
                    className="text-side"
                    data-aos="fade-left"
                    dangerouslySetInnerHTML={{ __html: item.content_text }}
                  />
                </div>
              </div>
            </section>
          );
        }

        // Section 2 style
        if (item.content_order === "2") {
          return (
            <section className="process-bg-gredient" key={item.id}>
              <div className="container">
                <div className="image-container" data-aos="fade-right">
                  <div
                    className="text-side about"
                    dangerouslySetInnerHTML={{ __html: item.content_text }}
                  />
                  <div className="image-side-about" data-aos="fade-left">
                    <img src={imageUrl} alt="Section visual" />
                  </div>
                </div>
              </div>
            </section>
          );
        }

        // Section 3 style
        if (item.content_order === "3") {
          return (
            <div className="container" key={item.id}>
              <div className="hiring-process" data-aos="fade-down">
                <div className="hiring-text">
                  <div
                    className="text-side about center-align"
                    dangerouslySetInnerHTML={{ __html: item.content_text }}
                  />
                </div>
              </div>
            </div>
          );
        }

        return null;
      })}
    </>
  );
};

export default RecruitmentPage;
